import { Modal } from "ui/Modal"
import BookingDetails from "ui/Booking/Details"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getClientBookingDetails } from "store/bookings"
import PropTypes from "prop-types"

const BookingDetailsModal = ({ open, handleOnCancel, bookingUuid, onCancelSuccess }) => {
  const dispatch = useDispatch()
  const { loading } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}

  useEffect(() => {
    dispatch(getClientBookingDetails(bookingUuid))
  }, [bookingUuid, dispatch])

  if (loading) return null

  return (
    <Modal open={open} onCancel={handleOnCancel}>
      <BookingDetails uuid={bookingUuid} />
    </Modal>
  )
}

BookingDetailsModal.propTypes = {
  open: PropTypes.bool,
  handleOnCancel: PropTypes.func,
  bookingUuid: PropTypes.string,
  onCancelSuccess: PropTypes.func
}

export default BookingDetailsModal
